<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ chinaStoreDisplay(item.ChinaStoreID) }}</td>
                <td>{{ storeDisplay(item.ReceivePlaceID) }}</td>
                <td class="text-end">{{ item.VolumeFrom | currency }}</td>
                <td class="text-end">{{ item.VolumeTo | currency }}</td>
                <td>{{ item.ProductType | display_value(product_types) }}</td>
                <td class="text-end" v-if="priceType == 2">{{ item.FirstAmount | currency }}</td>
                <td class="text-end" v-if="priceType == 2">{{ item.FixedFirstAmount | currency }}</td>
                <td class="text-end">{{ item.Amount | currency }}</td>
                <td class="text-end">{{ item.FixedAmount | currency }}</td>
                <td class="text-end">{{ item.DiscountRate | currency('',1) }}</td>
                <td>
                  {{ (item.ModifiedDate || item.CreatedDate) | display_date }}
                </td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)"
                    >fa-edit</v-icon
                  >
                  <v-icon medium @click="deleteItem(item.ID)"
                    >fa-trash-alt</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  props: ["priceId", "priceType"],
  data() {
    return {
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "feeVolume_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration.selected,
      items: (state) => state.feeVolume.all.data,
      total_rows: (state) => state.feeVolume.all.total,
      loading: (state) => state.feeVolume.loading,
      currentFeeWeight: (state) => state.feeVolume.selected,
      stores: (state) => state.commons.stores,
      chinaStores: (state) => state.commons.chinaStores,
    }),
    product_types() {
      return this.configuration && this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
    },
    headers() {
      let tmp = [
        {
          text: "Kho gửi",
          value: "ChinaStoreID",
          filterable: true,
          values: _.map(this.chinaStores, (item) => {
            return {
              value: item.ID,
              name: item.Name,
            };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Kho nhận",
          value: "ReceivePlaceID",
          filterable: true,
          values: _.map(this.stores, (item) => {
            return {
              value: item.ID,
              name: item.Name,
            };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Khối (Min)",
          value: "VolumeFrom",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Khối (Max)",
          value: "VolumeTo",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Loại hàng",
          value: "ProductType",
          filterable: true,
          values: this.product_types,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: this.priceType == 2 ? "Giá bán tiếp theo" : "Giá bán",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: this.priceType == 2 ? "Giá NY tiếp theo" : "Giá NY",
          value: "FixedAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "% CK hoa hồng",
          value: "DiscountRate",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ];
      if(this.priceType == 2) {
        tmp.splice(5, 0, {
          text: "Giá bán m3 đầu",
          value: "FirstAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        });
        tmp.splice(6, 0, {
          text: "Giá NY m3 đầu",
          value: "FixedFirstAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        });
      }
      return tmp;
    }
  },
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      if (this.priceId) {
        param.filter.push({
          column: "PriceID",
          value: this.priceId,
          condition: "equal",
        });
      }
      this.$store.dispatch("feeVolume/getList", param);
    },
    gotoDetail: function (id) {
      if(this.priceId > 0) {
        this.$emit('eventEditRow', id);
        return;
      }
      let routeData = this.$router.resolve({
        name: "FeeVolumeDetail",
        params: {
          Pid: id,
          title: `Chi tiết phí khối (#${id})`,
        },
      });
      window.open(routeData.href, "_blank");
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", {'id': id, 'viewName': this.viewName});
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "FeeVolumeDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới phí khối`,
        },
      });
    },
    storeDisplay(value) {
      const store = _.find(this.stores, { ID: value });
      return store ? store.Name : "";
    },
    chinaStoreDisplay(value) {
      const store = _.find(this.chinaStores, { ID: value });
      return store ? store.Name : "";
    },
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
      if(item.viewName == this.viewName) {
        this.$store.dispatch("feeVolume/removeDetail", item.id);
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
